import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { ACTIONS, ENocMAction, ENocMApplication, ENocMollakData, Mode, RemarkAction } from "../../../enocapi/entities";
import { enocMApi } from "../../../enocapi";
import { TabuProfile } from "@10x/sso/TabuProfile";
import { hideLoading, showErrorMessage, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import ListGridDataView from "@my-dld/components/DataView/ListGridDataView";
import Strings from "@my-dld/assets/strings";
import { DateUtil, LocaleUtil } from "@eres/core";
import ConfirmationPopup from "@my-dld/components/Popup/ConfirmationPopup";
import RemarkPopup from "@my-dld/components/ENocMollak/RemarkPopup";
import EnocMGridView from "../../../components/MyRequest/EnocMGridView";
import EnocMListView from "../../../components/MyRequest/EnocMListView";
import { normalizeENocRequest } from "../../../enocapi/services";
import { navigate } from "@my-dld/utils/StoreUtils";

interface Props extends RoutedViewProps {

}

interface State {
	isLoading: boolean;
	requests: ENocMApplication[];
	selectedRequest?: ENocMApplication;
	selectedAction?: ENocMAction;
	isAction: boolean;
	isEligible: boolean;
}

class EnocMollakRequets extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			isLoading: true,
			requests: [],
			isAction: false,
			isEligible: false,
		};
		this.onAction = this.onAction.bind( this );
	}

	componentDidMount() {
		this.loadEnocMRequests();
	}

	render() {
		const { isLoading, selectedAction, selectedRequest, requests } = this.state;
		return <React.Fragment>
			<ListGridDataView
				isLoading={ isLoading }
				dataAvailable={ requests.length > 0 }
				title={ Strings.enoc_request }
				renderListView={ this.renderListView }
				renderGridView={ this.renderGridView }/>
			{ selectedAction?.actionId === "CanCancelled" && selectedRequest &&
				<ConfirmationPopup
					primaryLabel={ Strings.continue }
					secondaryLabel={ Strings.cancel }
					message={ Strings.please_confirm_cancel_request }
					onConfirm={ () => {
						this.onConfirmCancelNOCRequest( selectedRequest );
					} }
					onCancel={ this.onHide }/>
			}
			{
				selectedAction?.actionId === "ViewRemark" && selectedRequest &&
				<RemarkPopup
					selectedRequest={ selectedRequest }
					onClose={ this.onHide }/>
			}
		</React.Fragment>;
	}

	onViewRequest( selectedRequest: ENocMApplication, mode: Mode ) {
		showLoading();
		enocMApi.getENocMollakRequest( selectedRequest.id! + "" ).then( resp => {
			hideLoading();
			let eNOCModel: Partial<ENocMollakData> = normalizeENocRequest( resp, mode );
			navigate( `/mydld/${ "enocm" }/${ eNOCModel.mollakPropertyId }`, undefined, {
				property: eNOCModel.property,
				eNOCModel: eNOCModel,
				buyers: eNOCModel.buyerInfo,
			} );
		} ).catch( exp => {
			hideLoading();
			showMessage( exp.message );
		} );
	}

	onConfirmCancelNOCRequest( selectedRequest: ENocMApplication ) {
		showLoading();
		enocMApi.cancelNOCRequest( selectedRequest.id! ).then( resp => {
			hideLoading();
			this.loadEnocMRequests();
			showMessage( Strings.cancel_tasken );
		} ).catch( exp => {
			hideLoading();
			showMessage( exp.message );
		} );
	}

	onHide = () => {
		this.setState( { selectedRequest: undefined, selectedAction: undefined } );
	};

	private setUpActionHeader() {
		let p = 0;
		let isEligible = false;
		const { requests } = this.state;
		requests.map( ( item: ENocMApplication ) => {
			isEligible = !!( item.eligibility && item.eligibility.nameEn && item.eligibility.nameEn !== "" );
			item.actions?.map( () => {
				p++;
			} );
		} );
		if ( p > 0 ) {
			this.setState( { isAction: true } );
		}
		this.setState( { isEligible: isEligible } );
	}

	private renderListView = () => {
		const { requests, isEligible, isAction } = this.state;
		return <div className="enoc-mollok-request"><EnocMListView
			items={ requests }
			isEligible={ isEligible }
			isAction={ isAction }
			onAction={ this.onAction }
		/></div>;
	};

	private renderGridView = () => {
		const { requests } = this.state;
		return <EnocMGridView
			items={ requests }
			onAction={ this.onAction }/>;
	};

	private onAction( action: ENocMAction, request: ENocMApplication ) {
		this.setState( { selectedAction: action, selectedRequest: request } );
		if ( action.actionId === "CanCancelled" || action.actionId === "ViewRemark" ) {
			this.setState( { selectedRequest: request, selectedAction: action } );
		} else if ( action.actionId === "CanReSubmit" ) {
			this.onViewRequest( request, Mode.EDIT );
		} else if ( action.actionId === "CanView" ) {
			this.onViewRequest( request, Mode.VIEW );
		}
	}

	private loadEnocMRequests() {
		enocMApi.getENocMollakRequests( TabuProfile.getParticipantNumber()! ).then( ( resp: any ) => {
			let result = resp.nocRequests.map( ( value: any ) => {
				let m = value;
				m.actions = value.actions?.map( ( action: string ) => {
					let p = ACTIONS.filter( ( value1: any ) => value1?.actionId === action );
					return {
						...p[ 0 ],
					};
				} );
				if ( value.remarks ) {
					m.actions?.push( RemarkAction );
				}
				return m;
			} );
			result.sort( ( a: ENocMApplication, b: ENocMApplication ) => b.submitDate > a.submitDate ? 1 : b.submitDate < a.submitDate ? -1 : 0 );
			this.setState( { requests: result, isLoading: false }, this.setUpActionHeader );
		} ).catch( ( reason ) => {
			this.setState( { isLoading: false } );
			showErrorMessage( reason );
		} );
	}
}

export default EnocMollakRequets;

export function getEnocReqNo( item: ENocMApplication ) {
	return item.requestNumber;
}

export function getEnocReqStatusClass( item: ENocMApplication ) {
	switch ( item.status?.identity ) {
		case ENocMollakRequestStatusId.Submit:
			return "submit";
		case ENocMollakRequestStatusId.Rejected:
			return "rejected";
		case ENocMollakRequestStatusId.Pending:
			return "pending";
		case ENocMollakRequestStatusId.Delete:
			return "cancel";
		case ENocMollakRequestStatusId.Decline:
			return "rejected";
		case ENocMollakRequestStatusId.Cancel:
			return "cancel";
		case ENocMollakRequestStatusId.Completed:
			return "completed";
		case ENocMollakRequestStatusId.Audit_Reviewed:
			return "review";
		case ENocMollakRequestStatusId.Audit_Rejected:
			return "rejected";
		case ENocMollakRequestStatusId.Audit_Accepted:
			return "completed";
		case ENocMollakRequestStatusId.Audit:
			return "under-auditing";
		case ENocMollakRequestStatusId.Approved:
			return "completed";
		case ENocMollakRequestStatusId.Active:
			return "completed";
		case ENocMollakRequestStatusId.Accepted:
			return "completed";
		case ENocMollakRequestStatusId.Approve_Rejected:
			return "rejected";
		case ENocMollakRequestStatusId.Approve_Accepted:
			return "rera-approval";
	}
}

export function getEnocReqStatus( item: ENocMApplication ) {
	return LocaleUtil.getLocalValue( item.status );
}

export function getEnocPropertyInfo( item: ENocMApplication ) {
	return item.propertyNumber + ", " + LocaleUtil.getLocalValue( item.propertyInfo );
}

export function getEnocSubmissionDate( item: ENocMApplication ) {
	let date = DateUtil.parseDate( item.submitDate, "YYYY-MM-DDThh:mm:ss" );
	return DateUtil.formatDate( date, "DD/MM/YYYY", "en" );
}

export function getEnocOwnerAssociation( item: ENocMApplication ) {
	return LocaleUtil.getLocalValue( item.ownerAssociation );
}

export function getEnocEligibility( item: ENocMApplication ) {
	return LocaleUtil.getLocalValue( item.eligibility );
}

enum ENocMollakRequestStatusId {
	Submit = 1,
	Rejected = 8,
	Pending = 4,
	Delete = 64,
	Decline = 256,
	Completed = 131072,
	Cancel = 65,
	Audit_Reviewed = 16384,
	Audit_Rejected = 6,
	Audit_Accepted = 11,
	Audit = 128,
	Approved = 2,
	Active = 16,
	Accepted = 2048,
	Approve_Rejected = 9,
	Approve_Accepted = 7,
}
